export interface IAddressComponentV2 {
  long_name: string;
  short_name: string;
  types: string[];
}

export interface IAddressDetails {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressLine4: string;
  city: string;
  state: string;
  stateCode: string;
  postalCode: string;
}

export interface IPlaceDetailsV2Response {
  id: string;
  place_id: string;
  name: string;
  formatted_address: string;
  address_components: IAddressComponentV2[];
  address: IAddressDetails;
  geometry: {
    location: {
      lat: number;
      lng: number;
    };
  };
}

